import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import {Checkbox, FormControlLabel} from "@mui/material";

const CustomCheckbox = ({
  name,
  defaultChecked,
  sx,
  label,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultChecked}
      render={({ field }) => {
        const dataValue = field.value;
        return (
          <FormControlLabel
            sx={sx}
            control={<Checkbox {...field} checked={Boolean(dataValue)} />}
            label={label}
          />
        );
      }}
    />
  );
};
export default CustomCheckbox;
